import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { ActivePlanState } from "../assets/interfaces/interfaces";
import useEnhancedNavigate from "./Session/helpers";
import { logClickEvent } from "../analytics";

// quota meter: navbar remaining-prompts bar, tap → bundle store.

const QuotaMeter = () => {
  const { plan, status } = useSelector((state: { plan: ActivePlanState }) => state.plan);
  const navigate = useEnhancedNavigate();

  const limit = plan?.dailyPrompts;
  // Hide until the plan fetch lands — dailyPrompts can arrive before promptsLeft and flash a wrong count.
  if (status !== "succeeded" || !limit || limit <= 0) return null;

  const remaining = Math.min(Math.max(plan.promptsLeft ?? 0, 0), limit);
  const used = limit - remaining;
  const pctUsed = (used / limit) * 100;

  const barColor = pctUsed >= 80 ? "bg-error-main" : pctUsed >= 50 ? "bg-warning-main" : "bg-tgpt-secondary-main";
  const textColor = pctUsed >= 80 ? "text-error-main" : pctUsed >= 50 ? "text-warning-main" : "text-mui-black-60 dark:text-mui-white-56";
  const tooltip = remaining === 0
    ? "No more prompts remaining today"
    : `${remaining} prompt${remaining !== 1 ? "s" : ""} remaining today`;

  return (
    <Tooltip title={tooltip} placement="top" arrow>
      <button
        type="button"
        aria-label={tooltip}
        onClick={() => {
          logClickEvent("quota_meter_click");
          navigate("/plans");
        }}
        className="flex items-center gap-2 px-2 py-1"
      >
        <div className="w-16 h-1.5 rounded-full bg-gray-200 dark:bg-gray-700 overflow-hidden">
          <div
            data-testid="quota-meter-fill"
            className={`h-full rounded-full transition-all ${barColor}`}
            style={{ width: `${pctUsed}%` }}
          />
        </div>
        <Typography variant="caption" component="span" className={textColor}>
          {remaining}
          /
          {limit}
        </Typography>
      </button>
    </Tooltip>
  );
};

export default QuotaMeter;
